import LocalizedContent from './LocalizedContent';

export default LocalizedContent;
